import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Entry } from '../models/Entry';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EntriesService {

  constructor(private http: HttpClient) { }

    getEntries() {
        return this.http.get<Entry[]>(environment.baseUrl + "entries");
    }
}
